import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

import { selectHasSession } from "features/auth/authSlice";

import paths from "routes/paths";

export const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  // A session the server refuses signs the user out, which lands here.
  const hasSession = useSelector(selectHasSession);
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!hasSession) {
    return <Navigate to={paths.cardLogin} state={{ from: location }} replace />;
  }

  if (requiredRoles.length > 0 && user) {
    const userHasRequiredRole = user.roles.some((role) =>
      requiredRoles.includes(role.name)
    );
    if (!userHasRequiredRole) {
      return <Navigate to={paths.error401} replace />;
    }
  }

  return children;
};
